import { useQuery } from "@tanstack/react-query";

import { getPublicFeatureFlags } from "~/lib/payload/featureFlags";
import { useSession } from "~/providers/SessionProvider";

export default function useFeatureFlags() {
  const { user, isLoading: isSessionLoading } = useSession();
  const userId = user?.id;

  const key = `feature-flags-${userId || "public"}`;

  const runUserQuery = Boolean(!isSessionLoading && userId);
  const runPublicQuery = Boolean(!isSessionLoading && !userId);

  // Get data and cache it.
  const { data, isLoading: isLoadingPublicFlags } = useQuery({
    queryKey: [key],
    queryFn: () => getPublicFeatureFlags(),
    enabled: runPublicQuery,
    staleTime: 5 * 60 * 1000, // 5 minutes - feature flags don't change often
    refetchOnWindowFocus: false,
  });

  if (runUserQuery) {
    return {
      data: user?.featureFlags,
      isLoading: isSessionLoading,
    };
  }

  if (runPublicQuery) {
    return {
      data: data?.data?.public,
      isLoading: isLoadingPublicFlags,
    };
  }

  return {
    data: null,
    isLoading: true,
  };
}
